module.exports = __webpack_public_path__ + "static/media/general.b45d7d72.png";